import React from 'react';
import { Layer, CardBody, Box } from 'grommet';
import {
	ButtonClose,
	SettingsModalBodyInner,
	SettingsModalHeader,
	SettingsModalWrap,
} from '@/components/settingsModal';
import { CloseIcon } from '@/components/icons';
import Html5QRScanner from './Html5QRScanner';

interface ReadQRModalProps {
	setShow: (show: boolean) => void;
	handleScan: (key: string) => void;
}

const ReadQRModal = ({ setShow, handleScan }: ReadQRModalProps) => (
	<Layer
		onEsc={() => setShow(false)}
		onClickOutside={() => setShow(false)}
		background="transparent"
	>
		<SettingsModalWrap height="auto" width="large">
			<CardBody>
				<ButtonClose
					onClick={() => setShow(false)}
					icon={<CloseIcon />}
					hoverIndicator
				/>
				<Box direction="column">
					<SettingsModalHeader>
						<span>Scan QR Code</span>
					</SettingsModalHeader>
					<SettingsModalBodyInner>
						<Html5QRScanner
							onScanSuccess={(result: string) => {
								handleScan(result);
								setShow(false);
							}}
						/>
					</SettingsModalBodyInner>
				</Box>
			</CardBody>
		</SettingsModalWrap>
	</Layer>
);

export default ReadQRModal;
